import { QUERY_KEY } from "~/src/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { type RequestError } from "~/src/models/error";
import { type PinnedNFTsResponse, pinNFTApi } from "../../apis/pin-nft";
import { useMemo } from "react";

export const useGetListPinnedNFTs: any = (
  address: string,
  enabled: boolean
) => {
  const { data, isPending } = useQuery<
    PinnedNFTsResponse,
    AxiosError<RequestError>
  >({
    queryKey: [QUERY_KEY.pinnedNFTs, QUERY_KEY.list, address],
    queryFn: async () => {
      return await pinNFTApi
        .getListPinnedNFTsOfPublicUser(address)
        .then(async (data: any) => {
          return data?.data;
        });
    },
    gcTime: 1000 * 60 * 60, // 1 hour
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled,
  });

  const pinnedNFTs = useMemo(() => {
    return (
      data?.nfts.map((nft) => ({
        id: `${Number(nft?.chainId)}_${nft.contract.toLowerCase()}_${nft.tokenId}`,
        amount: nft?.balance,
        token_id: nft?.tokenId,
        token_address: nft?.contract,
        chain_id: nft?.chainId,
        contract_type: nft?.ercType,
        owner_of: nft?.ownerAddress,
        token_uri: nft?.uri,
        name: nft?.name,
        symbol: nft?.symbol,
        normalized_metadata: {
          name: nft?.title,
          description: nft?.desc,
          animation_url: nft?.animationUrl,
          external_link: nft?.externalUrl,
          image: nft?.imageUrl,
        },
        data_type: nft?.dataType?.toLowerCase(),
        is_avacus_social:
          nft?.name === "Avacus Social Followed" ||
          nft?.name === "Avacus Social Following",
        media: {
          media_collection: {
            high: {
              height: 500,
              width: 500,
              url: nft?.imageUrl,
            },
          },
        },
      })) ?? []
    );
  }, [data?.nfts]);

  const pinnedMetaNFT = useMemo(() => {
    return {
      id: data?.id,
      owner_id: data?.owner_id,
    };
  }, [data?.id, data?.owner_id]);

  return {
    isPending,
    pinnedNFTs,
    pinnedMetaNFT,
  };
};
